const config = require('../../../config-env.json')

const ENV = process.env.API_ENV
const configEnv = config[ENV]

export const API = configEnv.API_URL
export const { API_LEROY } = configEnv
export const { API_TOTEM } = configEnv
export const {PING_URL_LOGIN} = configEnv
export const {PING_URL_LOGOUT} = configEnv
export default {
  URL: API,

  // Access
  LOGIN: `${API}/public/user-validation-ldap`,
  CHECK_PATH: `${API}/user/check-function-access`,
  ACCESS_LOGIN_SAVE: `${API}/accessLogin/save`,

  // Maintenance block
  MAINTENANCE_CONSULT: `${API}/public/maintenance-block/consult/portal`,

  // Routes permissions
  ROUTE_PERMISSIONS: `${API}/routes/fetch`,

  // Locales
  LOCALES_KEYS: `${API}/public/locales/list-keys`,
  LOCALES_LAST_UPDATE: `${API}/public/locales/check-last-update`,

  // Menus
  MENU_LIST_CHILDREN: `${API}/menus/listMenusForProfiles`,
  MENUS_LIST: `${API}/menus/listWeb`,
  ACCESS_MENUS: `${API}/accessMenus/save`,
  NEW_HOME_MENUS: `${API}/menus/filterMenu`,

  // Punctual Adjust Parameters
  MENU_PUNCTUAL_ADJUST_PARAMETERS_GET: `${API}/global-punctual-adjust-parameters/get-parameters`,
  MENU_PUNCTUAL_ADJUST_PARAMETERS_SAVE: `${API}/global-punctual-adjust-parameters/save`,

  // Punctual Adjust Parameters By Store
  MENU_PUNCTUAL_ADJUST_BY_STORE_PARAMETERS_FIND: `${API}/punctual-adjust-params/find`,
  MENU_PUNCTUAL_ADJUST_BY_STORE_PARAMETERS_SAVE: `${API}/punctual-adjust-params/save`,

  // Missions
  MISSION_LIST: `${API}/missions/findAll`,

  // Versions
  VERSION_LIST: `${API}/versions/findAll`,

  // Menus_Mission
  MENU_MISSION_LIST: `${API}/missionMenu/list`,
  MENU_MISSION_CHECKLIST: `${API}/missionMenu/checkList`,
  MENU_MISSION_SAVE: `${API}/missionMenu/saveAll`,
  MENU_MISSION_REMOVE: `${API}/missionMenu/deleteAll`,
  FETCH_MENU_MISSIONS_V2: `${API}/missionMenu/v2/list`,
  SAVE_MENU_MISSIONS_V2: `${API}/missionMenu/v2/saveAll`,
  UPDATE_MENU_MISSIONS: `${API}/missionMenu/update`,
  UPDATE_MENU_MISSIONS_PERMISSIONS: `${API}/missionMenu/update-permissions`,
  MENU_MISSION_REPORT_CSV: `${API}/missionMenu/reportAsCsv`,

  // Reports
  COMMERCIAL_MANAGEMENT_REPORT_CSV: `${API}/commercialManagement/reportAsCsv`,
  V2_COMMERCIAL_MANAGEMENT_REPORT_CSV: `${API}/commercialManagement/v2ReportAsCsvFlux`,

  // COMMERCIAL MANAGEMENT
  COMMERCIAL_MANAGEMENT_REPORT: `${API}/commercialManagement/report`,

  // Ruptures
  RUPTURES: `${API}/rupture/start`,
  RUPTURE_REPORT_CSV: `${API}/rupture/reportAsCsv`,
  RUPTURE_REPORT_CSV_FLUX: `${API}/rupture/reportAsCsv/flux`,
  RUPTURE_REPORT_PDF: `${API}/rupture/reportAsPdfBase64`,
  RUPTURE_FIND_FILTER: `${API}/rupture/findFilter`,

  // ??????

  // Code 8 Occurencies
  CODE8OCCURRENCES: `${API}/code8/start`,
  CODE8OCCURRENCES_REPORT_CSV: `${API}/code8/reportAsCsv`,
  CODE8OCCURRENCES_RECURRING_REPORT_CSV: `${API}/code8/reportAsCsvRecurring`,
  CODE80OCURRENCES_V2: `${API}/event-management/list-occurrences`,
  CODE8OCCURRENCES_REPORT_CSV_V2: `${API}/event-management/reportAsCsv`,
  CODE8RECURRENCES_RECURRING_REPORT_CSV_V2: `${API}/event-management/reportAsRecurrentCsv`,
  CODE8RECURRENCES_SECTIONS_REPORT_CSV_V2: `${API}/event-management/reportAsOcrSectionsCsv`,
  CODE8OCCURRENCE_STORES_REPORT_CSV: `${API}/event-management/reportAsOcrStoresCsv`,
  CODE8REVENUE_SECTIONS_REPORT_CSV: `${API}/event-management/reportAsRevenueSectionsCsv`,
  CODE8REVENUE_STORES_REPORT_CSV: `${API}/event-management/reportAsRevenueStoresCsv`,


  // CommercialManagements
  COMMERCIAL_MANAGEMENTS: `${API}/commercialManagement/start`,
  COMMERCIAL_MANAGEMENT_REPORT_PDF: `${API}/commercialManagement/reportAsPdfBase64`,

  // Branches
  BRANCHES: `${API}/branch/list`,

  // Mobile Update
  MOBILE_UPDATE_LIST: `${API}/mobile-updates/list`,
  MOBILE_UPDATE_SAVE: `${API}/mobile-updates/save`,
  MOBILE_UPDATE_REMOVE: `${API}/mobile-updates/delete`,

  // Lm Express
  LMEXPRESS: `${API}/express/start`,
  LMEXPRESS_REPORT_CSV: `${API}/express/reportAsCsv`,
  LMEXPRESS_PARAMETERS: `${API}/express/parameters`,

  // Menus_Mission
  SUGGESTION_LIST: `${API}/suggestions/list-filters`,
  SUGGESTION_SAVE: `${API}/suggestions/save`,
  SUGGESTION_DELETE: `${API}/suggestions/delete`,

  // Vídeos
  VIDEOS_HOME: `${API}/videos/home`,
  VIDEOS_LIST: `${API}/videos/findAll`,
  VIDEOS_SAVE: `${API}/videos/save`,
  VIDEOS_REMOVE: `${API}/videos/delete`,
  VIDEOS_REMOVE_ALL: `${API}/videos/deleteAll`,
  VIDEOS_LATEST: `${API}/videos/get-latest-video-data`,
  HOME_USER_VERSION_VALIDATION: `${API}/accessLogin/user-version-validation`,
  HOME_SPRINT_NOTES: `${API}/sprint-notes/find-sprint-notes-by-version-code`,

  // Analytics
  ANALYTICS_DEVICES: `${API}/versions/find-devices-updated`,
  ANALYTICS_USERS: `${API}/accessLogin/find-active-inactive-users`,
  ANALYTICS_MENUS: `${API}/accessMenus/get-top-accessed-menus`,
  ANALYTICS_LIST_ACCESSES: `${API}/accessMenus/list-most-accessed`,
  ANALYTICS_LIST_ACCESSES_V2: `${API}/accessMenus/v2/list-most-accessed`,
  ANALYTICS_REPORT: `${API}/accessMenus/list-most-accessed/reportAsCsv`,
  ACCESS_MENUS_REPORT_STORES: `${API}/accessMenus/list-most-accessed/reportAsStore`,
  ACCESS_MENUS_REPORT_LDAPS:  `${API}/accessMenus/list-most-accessed/reportAsLdap`,
  ACCESS_MENUS_REPORT_MISSIONS:  `${API}/accessMenus/list-most-accessed/reportAsMissions`,
  ACCESS_MENUS_REPORT_FILTER_LDAPS: `${API}/accessMenus/list-most-accessed/reportAsFilterLdaps`,
  ACCESS_MENUS_REPORT_FILTER_MISSIONS: `${API}/accessMenus/list-most-accessed/reportAsFilterMissions`,
  RELATORY_PERMISSIONS: `${API}/accessMenus/list-menus-web`,
  MOUNT_STORES: `${API}/accessMenus/mountStores`,

  // IRC
  FIND_LOG_DETAIL : `${API}/inventory/irc-log-detail`,
  IRC_REPORT_FLUX_CSV:`${API}/inventory/ircReportAsCsv`,
  INVENTORY_CRITERIA_LIST: `${API}/inventory-criteria/list`,
  IS_USER_IN_HEADQUARTERS: `${API}/is-user-in-headquarters`,
  INVENTORY_CRITERIA_SAVE: `${API}/inventory-criteria/save`,
  INVENTORY_CRITERIA_FETCH_ID: `${API}/inventory-criteria/find-by-id`,
  INVENTORY_CRITERIA_DELETE: `${API}/inventory-criteria/deleteLogic`,
  INVENTORY_CRITERIA_VALIDATE_PRODUCTS: `${API}/inventory-criteria/validateProducts`,

  // IRC SUPPLY
  IRC_MODELS_LIST: `${API}/inventory-supply/positions/list`,
  IRC_LIST_POSITIONS : `${API}/inventory-supply/positions`,
  SUPPLY_MULTIPLE_LIST_POSITIONS : `${API}/inventory-supply/multiple-positions`,
  IRC_SAVE_POSITIONS: `${API}/inventory-supply/positions/save`,
  IRC_EXCLUDE_LIST: `${API}/inventory-supply/positions/exclude/`,

   // IRC AUTONOMOUS
  MENU_IRC_AUTONOMOUS_GET: `${API}/irc-autonomous-parameters/find-latest`,
  MENU_IRC_AUTONOMOUS_SAVE: `${API}/irc-autonomous-parameters/save`,

  // Sections
  SECTIONS_HIERARCHY: `${API}/product/find-sections`,
  FIND_SUBSECTIONS: `${API}/product/find-subsections`,

  // Gama
  GAMA_FILTER: `${API}/gama/findFilter`,
  GAMA_SAVE: `${API}/gama/persist`,

  // Schedule block
  SCHEDULE_BRANCH_LIST: `${API}/schedule-block/findFilter`,
  SCHEDULE_BRANCH_SAVE: `${API}/schedule-block/save`,
  SCHEDULE_BRANCH_DELETE: `${API}/schedule-block/delete`,
  SCHEDULE_BRANCH_DELETE_MULTIPLE: `${API}/schedule-block/delete-multiple`,

  // Query log
  QUERY_LOG_LIST: `${API}/logs/list-log`,

  // Weekly block
  WEEKLY_BLOCK_FIND: `${API}/weekly-block/find`,
  WEEKLY_BLOCK_SAVE: `${API}/weekly-block/save-multiples`,

  // Justifications
  LIST_JUSTIFICATIONS: `${API}/justifications/list`,
  SAVE_JUSTIFICATION: `${API}/justifications/save`,
  REMOVE_JUSTIFICATION: `${API}/justifications/delete`,

  // IRC Justifications
  IRC_LIST_JUSTIFICATIONS: `${API}/irc-justifications/list-all-justification`,
  IRC_SAVE_JUSTIFICATION: `${API}/irc-justifications/save`,
  IRC_SAVE_ALL_JUSTIFICATION: `${API}/irc-justifications/saveAll`,
  IRC_UPDATE_JUSTIFICATION: `${API}/irc-justifications/edit`,
  IRC_DELETE_JUSTIFICATION: `${API}/irc-justifications/delete`,

  // Sales coaching
  SALES_COACHING_REPORT: `${API}/sales-coaching/report/asCsv`,
  SALES_COACHING_COUNT: `${API}/sales-coaching/count`,

  // Rotative Inventory
  ROTATIVE_INVENTORY_FIND: `${API}/inventory/find`,
  V2_ROTATIVE_INVENTORY_FIND: `${API}/inventory/v2/irc-find`,
  ROTATIVE_INVENTORY_REPORT: `${API}/inventory/reportAsCsv`,
  ROTATIVE_INVENTORY_INACTIVATE: `${API}/inventory/inactivate-rotative-inventory`,

  ROTATIVE_INVENTORY_FLUX: `${API}/inventory/v3/find`,
  ROTATIVE_INVENTORY_FLUX_REPORT: `${API}/inventory/ruptureReportAsCsv`,

// Zero Cost Dpac items
  ZERO_COST_DPAC_ITEMS_FIND: `${API}/inventory/find-no-dpac`,
  ZERO_COST_DPAC_ITEMS_REPORT_CSV: `${API}/inventory/reportNoDpacAsCsv`,

  // Total Accuracy
  TOTAL_ACCURACY_FIND: `${API}/total-accuracy/find-total-accuracy`,
  TOTAL_ACCURACY_FIND_V2: `${API}/total-accuracy/v2/find-total-accuracy`,
  TOTAL_ACCURACY_REPORT_CSV: `${API}/total-accuracy/reportAsCsv`,
  TOTAL_ACCURACY_REPORT_CSV_V2: `${API}/total-accuracy/v2/reportAsCsv`,

  // Sections Accuracy
  SECTIONS_ACCURACY_FIND: `${API}/section-accuracy/find-section-accuracy`,
  SECTION_ACCURACY_REPORT_CSV: `${API}/section-accuracy/reportAsCsv`,

  // Supply Acc-Effec
  SUPPLY_FETCH_ACC_EFFEC: `${API}/irc-supply/supply-acc-effec`,
  // Higher Adjustments
  HIGHER_ADJUSTMENTS_FIND: `${API}/higherAdjustments/find`,
  HIGHER_ADJUSTMENTS_REPORT: `${API}/higherAdjustments/reportAsCsv`,

  // Section Block
  LIST_SECTION_BLOCK: `${API}/section-block/list`,
  SAVE_SECTION_BLOCK: `${API}/section-block/save`,
  DELETE_SECTION_BLOCK: `${API}/section-block/delete-section-block`,
  LIST_SECTION_BLOCK_V2: `${API}/section-block/v2/list`,

  // Datasheet Management
  LIST_DATASHEET_MANAGEMENT: `${API}/datasheet-management/fetch-all`,
  FILTER_LIST_DATASHEET_MANAGEMENT: `${API}/datasheet-management/find-by-params`,
  FILTER_LIST_DATASHEET_MANAGEMENT_FLUX: `${API}/datasheet-management/find-by-params-flux`,

  SAVE_DATASHEET_MANAGEMENT: `${API}/datasheet-management/save`,
  DELETE_DATASHEET_MANAGEMENT: `${API}/datasheet-management/delete-datasheet-management`,
  DATASHEET_MANAGEMENT_REPORT_AS_CSV: `${API}/datasheet-management/reportAsCsvFlux`,

  // Datasheet Format
  LIST_DATASHEET_FORMAT: `${API}/datasheet-format/findAllFlux`,

  // Logo Brands
  FETCH_ALL_LOGO_BRANDS: `${API}/logo-brands/findAll`,
  FETCH_LOGO_BRANDS: `${API}/logo-brands/findFilter`,
  SAVE_LOGO_BRANDS: `${API}/logo-brands/save`,
  DELETE_LOGO_BRANDS: `${API}/logo-brands/delete`,

  KARDEX_FIND: `${API}/kardex/find`,
  KARDEX_REPORT: `${API}/kardex/reportAsCsv`,

  // Parameters
  PARAMETER_FIND: `${API}/parameter/list-filters`,
  PARAMETER_GET: `${API}/parameter/get-parameter`,
  PING_ID_PARAMETER: `${API}/external/ping-auth-parameter`,
  PARAMETER_SAVE: `${API}/parameter/save`,

  // Parameters
  TOTEM_PARAMETER_FIND: `${API_TOTEM}/parameter/external/list-filters`,
  TOTEM_PARAMETER_SAVE: `${API_TOTEM}/parameter/external/save`,

  // Totem Reports
  TOTEM_FILTER_REPORTS: `${API_TOTEM}/queue/external/reports`,
  TOTEM_FILTER_REPORTS_NEW: `${API_TOTEM}/queue/external/v2/reports`,
  TOTEM_FILTER_REPORTS_NEW_FLUX: `${API_TOTEM}/queue/external/v4/reports`,
  TOTEM_FILTER_REPORTS_CSV_NEW_FLUX: `${API_TOTEM}/queue/external/v4/reports/csv`,

  // Totem auth
  TOTEM_AUTH: `${API_TOTEM}/public/user-validation`,
  // Totem Logs
  TOTEM_LOG: `${API_TOTEM}/totem-logs`,
  TOTEM_LOG_EXCLUDED: `${API_TOTEM}/totem-logs/listExcluded`,

  SAVE_FEATURE_CHECK: `${API}/feature-check/check`,
  FETCH_FEATURE_CHECK: `${API}/logo-brands/find`,

  ENABLE_NOTIFIER: `${API}/public/sse-emiter/enable-notifier`,

  FETCH_ADJUSTMENT_VALUES: `${API}/adjustment-values/fetch`,
  V2_FETCH_ADJUSTMENT_VALUES: `${API}/adjustment-values/v2/fetch`,
  ADJUSTMENT_VALUES_CSV: `${API}/adjustment-values/reportAsCsv`,
  V2_ADJUSTMENT_VALUES_CSV: `${API}/adjustment-values/v2/reportAsCsv`,

  // Adjustment-done report
  FETCH_ADJUSTMENT_DONE_FIND: `${API}/adjustment-done/fetch`,
  FETCH_ADJUSTMENT_DONE_CSV: `${API}/adjustment-done/reportAsCsv`,

  // Linear Conferences
  FETCH_LINEAR_CONFERENCE: `${API}/linear/report`,
  LINEAR_CSV: `${API}/linear/reportAsCsv`,

  FETCH_LINEAR_CONFERENCE_FLUX: `${API}/linear/v2/report`,
  LINEAR_FLUX_CSV: `${API}/linear/fluxReportAsCsv`,



  // Manager Branch Mission
  MANAGER_BRANCH_MISSION_LIST: `${API}/manager-branch-mission/listAll`,
  MANAGER_BRANCH_MISSION_LIST_MISSION: `${API}/missions/listMissionApprovers`,
  MANAGER_BRANCH_MISSION_SAVE: `${API}/manager-branch-mission/saveMission`,
  MANAGER_BRANCH_MISSION_REMOVE: `${API}/manager-branch-mission/deleteByMission`,

  // Local users
  FETCH_LOCAL_USERS: `${API}/local-users/findFilter`,
  SAVE_LOCAL_USERS: `${API}/local-users/save`,
  DELETE_LOCAL_USERS: `${API}/local-users/delete`,

  // Tracking monitor
  FETCH_SALES_ORDER_LIST: `${API_TOTEM}/orders/external/findByStore`,
  FETCH_TRACKING_MONITOR_REMOVAL_REASON_LIST: `${API_TOTEM}/trackingMonitorRemovalReason/external/findAll`,
  SAVE_TRACKING_MONITOR_REMOVAL: `${API_TOTEM}/orders/external/removeFromMonitor`,

  // Justifications
  LIST_JUSTIFICATIONS_PA: `${API}/justificationsPa/list`,
  SAVE_JUSTIFICATION_PA: `${API}/justificationsPa/save/v2`,
  REMOVE_JUSTIFICATION_PA: `${API}/justificationsPa/delete`,

  // Linear Conference Justifications
  LIST_LINEAR_CONFERENCE_JUSTIFICATIONS: `${API}/linear-conference/justifications/list`,
  SAVE_LINEAR_CONFERENCE_JUSTIFICATION: `${API}/linear-conference/justifications/save/v2`,
  REMOVE_LINEAR_CONFERENCE_JUSTIFICATION: `${API}/linear-conference/justifications/delete`,

  // Demarcate Justifications
  LIST_JUSTIFICATION_DEMARCATE: `${API}/justificationDemarcate/list`,
  SAVE_JUSTIFICATION_DEMARCATE: `${API}/justificationDemarcate/save`,
  REMOVE_JUSTIFICATION_DEMARCATE: `${API}/justificationDemarcate/delete`,

  // Demarcate Disapproval Justifications
  LIST_DEMARCATE_DISAPPROVAL_JUSTIFICATION: `${API}/demarcateDisapprovalJustification/list`,
  SAVE_DEMARCATE_DISAPPROVAL_JUSTIFICATION: `${API}/demarcateDisapprovalJustification/save`,
  REMOVE_DEMARCATE_DISAPPROVAL_JUSTIFICATION: `${API}/demarcateDisapprovalJustification/delete`,

  // justification-disapproval-use-and-consumption
  JUSTIFICATION_DISAPPROVAL_USE_AND_CONSUMPTION: `${API}/justification-disapproval-use-and-consumption`,

  // Stock transfer report
  STOCK_TRANSFER_REPORT: `${API}/stockTransfer/report`,
  STOCK_TRANSFER_REPORT_CSV: `${API}/stockTransfer/reportAsCsv`,
  FIND_BY_CODE_PROCESS: `${API}/log-stock-transfer/find-by-code-process`,


  // Stock transfer mission block
  FETCH_STOCK_TRANSFER_MISSION_BLOCK: `${API}/mission-deposit-block/fetch`,
  SAVE_STOCK_TRANSFER_MISSION_BLOCK: `${API}/mission-deposit-block/save`,
  UPDATE_STOCK_TRANSFER_MISSIONS_BLOCK: `${API}/mission-deposit-block/updateAll`,

  // Deposit
  FETCH_DEPOSIT: `${API}/deposit/fetch`,

  // Help Config
  FETCH_HELP_CONFIG: `${API}/help-config/list-filter`,
  FETCH_HELP_FUNC: `${API}/menus/help-config`,
  FETCH_TAG: `${API}/help-tag/options`,
  SAVE_HELP_CONFIG: `${API}/help-config/save`,
  REMOVE_HELP_CONFIG: `${API}/help-config/delete`,

  // Pricebanner config
  DELETE_PRICEBANNER_CONFIG: `${API}/pricebanner-config/delete`,
  FETCH_PRICEBANNER_CONFIG: `${API}/pricebanner-config/findFilter`,
  SAVE_PRICEBANNER_CONFIG: `${API}/pricebanner-config/save`,

   // Price banner params
  FETCH_PRICEBANNER_PARAMS: `${API}/price-banner-params/fetch-all`,
  DELETE_PRICEBANNER_PARAMS: `${API}/price-banner-params/delete-params`,
  SAVE_PRICEBANNER_PARAMS: `${API}/price-banner-params/save-params`,
  UPDATE_PRICEBANNER_PARAMS: `${API}/price-banner-params/update-params`,

  // Price banner list and products
  FETCH_PRICEBANNER_LIST: `${API}/price-banner-list/fetch-all`,
  FIND_PRICEBANNER_LIST: `${API}/price-banner-list/find`,
  EXPORT_PRICEBANNER_PRODUCTS: `${API}/price-banner-list/find/export`,
  DELETE_PRICEBANNER_LIST: `${API}/price-banner-list/delete-list`,
  DELETE_PRICEBANNER_PRODUCT: `${API}/price-banner-list/delete-product`,
  UPDATE_PRICEBANNER_LIST: `${API}/price-banner-list/update-list`,
  UPLOAD_PRICEBANNER_LIST: `${API}/price-banner-list/upload-list`,
  VALIDATE_PRICEBANNER_PRODUCTS: `${API}/price-banner-list/validate-products`,
  VALIDATE_PRICEBANNER_BRANCHES: `${API}/price-banner-list/validate-branches`,
  ADD_PRODUCTS_TO_LIST: `${API}/price-banner-list/add-products`,
  FETCH_PRICEBANNER_THEMES: `${API}/configuracao-modelo/list-themes-allowed-for-lists`,
  FETCH_PRICEBANNER_LISTS: `${API}/price-banner-list/lists`,
  FETCH_PRICEBANNER_DYNAMICS: `${API}/configuracao-modelo/list-dynamics`,
  UPDATE_PRODUCT_EXTRAS: `${API}/price-banner-list/update-product-extras`,

  // Satisfaction survey
  LIST_EVALUATIONS: `${API}/evaluations/list-evaluations`,
  CREATE_EVALUATION: `${API}/evaluations/create-evaluation`,
  DOWNLOAD_EVALUATION_REPORT: `${API}/evaluations/download-evaluations`,
  UPDATE_EVALUATION: `${API}/evaluations/update-evaluation`,
  DELETE_EVALUATION: `${API}/evaluations/delete-evaluation`,

  // Pricefy
  FETCH_PRICEFY_CONFIG: `${API}/pricefy/find-parcel-dynamic`,

  // Parcel
  FETCH_PARCEL: `${API}/parcel/findAll`,

  // Delimit report
  DELIMIT_REPORT: `${API}/demarcate/report`,
  DELIMIT_REPORT_CSV: `${API}/demarcate/reportAsCsv`,

  // Stock Transfer Approvers
  STOCK_TRANSFER_APPROVERS_LIST: `${API}/stock-transfer-approvers/filtersAll`,
  STOCK_TRANSFER_APPROVERS_SAVE: `${API}/stock-transfer-approvers/preserve`,
  STOCK_TRANSFER_APPROVERS_REMOVE: `${API}/stock-transfer-approvers/remove`,
  STOCK_TRANSFER_APPROVERS_LIST_MISSION: `${API}/stock-transfer-approvers/filterMissionApprovers`,

  // Price Audit
  GET_GRAPH_DATA: `${API}/priceAudit/getGraphData`,
  FETCH_PRICE_AUDIT: `${API}/priceAudit/fetch`,
  REPORT_GRAPH_STORES_CSV:`${API}/priceAudit/reportGraphStoresCsv`,
  REPORT_GRAPH_SECTIONS_CSV:`${API}/priceAudit/reportGraphSectionsCsv`,
  REPORT_TABLE_CSV: `${API}/priceAudit/reportTableCsv`,

  // Irc Supply
  FETCH_POSITIONS_NOT_COUNTED: `${API}/irc-supply/report-positions-not-counted`,
  FETCH_SUPPLY_HISTORY_COUNT: `${API}/irc-supply/report-supply-count-history`,

  SUPPLY_HISTORY_COUNT_CSV: `${API}/irc-supply/report-supply-count-history-csv`,
  SUPPLY_ACC_EFFEC_CSV: `${API}/irc-supply/supply-acc-effec-report`,
  // Use and Consume Justifications
  LIST_USE_CONSUME_JUSTIFICATION: `${API}/use-consume-justification/list`,
  SAVE_USE_CONSUME_JUSTIFICATION: `${API}/use-consume-justification/save`,
  REMOVE_USE_CONSUME_JUSTIFICATION: `${API}/use-consume-justification/delete`,
  V2_USE_CONSUME_REPORT: `${API}/use-consume/v2/reportAsCsv`,

  // Manager Branch Mission
  USAGE_CONSUMPTION_APPROVERS_LIST: `${API}/usage-consumption-approvers/listAll`,
  USAGE_CONSUMPTION_APPROVERS_SAVE: `${API}/usage-consumption-approvers/saveMission`,
  USAGE_CONSUMPTION_APPROVERS_REMOVE: `${API}/usage-consumption-approvers/deleteByMission`,
  USAGE_CONSUMPTION_APPROVERS_LIST_MISSION: `${API}/missions/filterMissionApprovers`,


  USE_COSUME_V2_REPORT: `${API}/use-consume/v2/report`,
  USE_CONSUME_APPROVERS_LIST: `${API}/use-consume-approvers/filtersAll`,
  USE_CONSUME_APPROVERS_SAVE: `${API}/use-consume-approvers/preserve`,
  USE_CONSUME_APPROVERS_REMOVE: `${API}/use-consume-approvers/remove`,
  USE_CONSUME_APPROVERS_EDIT: `${API}/use-consume-approvers/edit`,
  USE_CONSUME_APPROVERS_LIST_MISSION: `${API}/use-consume-approvers/filterMissionApprovers`,

  // Exclusion subtype
  FETCH_EXCLUSION_SUBTYPE: `${API}/exclusion-subtype/listFilter`,
  SAVE_EXCLUSION_SUBTYPE: `${API}/exclusion-subtype/massiveSave`,
  REMOVE_EXCLUSION_SUBTYPE: `${API}/exclusion-subtype/deleteById`,

  // Usage and consumption report
  USAGE_CONSUMPTION_REPORT: `${API}/use-consume/report`,
  FETCH_USAGE_CONSUMPTION_STATUS: `${API}/use-consume/fetch-usage-consumption-status`,
  USAGE_CONSUMPTION_REPORT_CSV: `${API}/use-consume/reportAsCsv`,

  // New Home quick access
  FETCH_QUICK_ACCESS: `${API}/quickAccess/list`,
  SAVE_QUICK_ACCESS: `${API}/quickAccess`,

  // beeping report
  BEEPING_REPORT: `${API}/showcase/find`,
  BEEPING_REPORT_CSV: `${API}/showcase/reportAsCsv`,

  // demarcate justifies
  DEMARCATE_JUSTIFIES_FILTER: `${API}/justifications-demarcate/list-filter`,
  DEMARCATE_JUSTIFIES_SAVE_AND_UPDATE: `${API}/justifications-demarcate/save-justifies`,
  DEMARCATE_JUSTIFIES_DELETE: `${API}/justifications-demarcate/delete-justify`,

  // Ping ID
  PING_AUTHORIZE: `${API}/oauth2/authorize/ping`,
  PING_AUTHORIZE_V2: `${API}/public/user-validation-ping-id`,
  PING_LOGOUT: `${API}/oauth2/logout`,
  GET_USER_INFO: `${API}/get-user-info`,

  MANAGER_REPORT: `${API}/manager-report/find`,

  // NEXP
  SAVE_PARAMS_NEXP: `${API}/nexp/save`,
  FIND_PARAMS_NEXP: `${API}/nexp/findFilter`,

  // SUPPLY
  SAVE_PARAMS_SUPPLY: `${API}/irc-supply/save-params`,
  FIND_PARAMS_SUPPLY: `${API}/irc-supply/find-params`,

  // ATTRIBUTE
  SAVE_ATTRIBUTE_PICTOGRAMS: `${API}/pictogram/preserveBase64`,
  SAVE_ATTRIBUTE_PICTOGRAMS_FORMDATA: `${API}/pictogram/preserve`,
  UPDATE_ATTRIBUTE_PICTOGRAMS: `${API}/pictogram/editBase64`,
  UPDATE_ATTRIBUTE_PICTOGRAMS_FORMDATA: `${API}/pictogram/edit`,
  FETCH_ATTRIBUTE_PICTOGRAMS: `${API}/pictogram/filterAll`,
  DELETE_ATTRIBUTE_PICTOGRAMS: `${API}/pictogram/remove`,
  CHECK_ATTRIBUTE_NAME: `${API}/pictogram/checkAttribute`,

  EXTERNAL_APIS_FIND: `${API}/external-apis/list-filters`,
  EXTERNAL_APIS_SAVE: `${API}/external-apis/save`,
  EXTERNAL_APIS_TOGGLE_TARGET: `${API}/external-apis`,

  // WAREHOUSE APPROVALS
  WAREHOUSE_APPROVALS_FIND: `${API}/warehouse-approval/find`,
  WAREHOUSE_APPROVALS_UPDATE: `${API}/warehouse-approval`
}
